import { ca } from '@cian/analytics';

import { getTermValue } from '../../../packages/JsonQuery';
import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { IDailyRentOfferForMobileSite } from '../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { OFFERS_ON_PAGE, trackingReasonToListingType } from '../constants';

interface ITrackBreadcrumbsPrivateProps {
  offersIds: { id: number; position: number; offerType: string }[];
  offersLength: number;
  pageNumber: number;
  jsonQuery: IJsonQuery;
  queryString: string;
}

const trackBreadcrumbsClickPrivate = ({
  offersIds,
  offersLength,
  pageNumber,
  jsonQuery,
  queryString,
}: ITrackBreadcrumbsPrivateProps) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Mob_BreadCrumbs',
    action: 'click',
    page: {
      pageType: 'Listing',
      listingType: trackingReasonToListingType['all_objects_on_map'],
      offersQty: offersLength < OFFERS_ON_PAGE ? offersLength : OFFERS_ON_PAGE,
      pageNumber,
      extra: {
        reason: 'all_objects_on_map',
        mobileWebsiteType: 'new',
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    products: offersIds,
    sc: jsonQuery,
  });
};

interface ITrackBreadcrumbsProps {
  offers: IDailyRentOfferForMobileSite[];
  jsonQuery: IJsonQuery;
  queryString: string;
}

export const trackBreadcrumbsClick = ({ offers, jsonQuery, queryString }: ITrackBreadcrumbsProps) => {
  if (!offers.length) {
    return;
  }

  const pageNumber = getTermValue('page')(jsonQuery) || 1;
  const offersPositionOffset = (pageNumber - 1) * OFFERS_ON_PAGE;
  const offersIds = offers.reduce((acc, offer, index) => {
    return [...acc, { id: offer.id, position: index + 1 + offersPositionOffset, offerType: 'offer' }];
  }, []);
  trackBreadcrumbsClickPrivate({
    offersIds,
    offersLength: offersIds.length,
    pageNumber,
    jsonQuery,
    queryString,
  });
};
